import React from 'react';
import { 
    Card, 
    CardContent, 
    Typography, 
    Box,
    CircularProgress 
} from '@mui/material';

interface DashboardCardProps {
    title: string;
    value: string | number;
    subtitle?: string;
    icon?: React.ReactNode;
    loading?: boolean;
    color?: 'primary' | 'secondary' | 'success' | 'warning' | 'error';
}

const DashboardCard: React.FC<DashboardCardProps> = ({ 
    title, 
    value, 
    subtitle, 
    icon, 
    loading = false,
    color = 'primary'
}) => {
    const getColorValue = (color: string) => {
        switch (color) {
            case 'primary': return '#1976d2';
            case 'secondary': return '#9c27b0';
            case 'success': return '#2e7d32';
            case 'warning': return '#ed6c02';
            case 'error': return '#d32f2f';
            default: return '#1976d2';
        }
    };

    return (
        <Card sx={{ height: '100%', display: 'flex', flexDirection: 'column' }}>
            <CardContent sx={{ flexGrow: 1 }}>
                <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
                    {icon && (
                        <Box sx={{ mr: 1, color: getColorValue(color) }}>
                            {icon}
                        </Box>
                    )}
                    <Typography variant="h6" component="div" color="text.secondary">
                        {title}
                    </Typography>
                </Box>
                
                {loading ? (
                    <Box sx={{ display: 'flex', justifyContent: 'center', my: 2 }}>
                        <CircularProgress size={40} />
                    </Box>
                ) : (
                    <Typography variant="h4" component="div" sx={{ mb: 1, color: getColorValue(color) }}>
                        {value}
                    </Typography>
                )}
                
                {subtitle && (
                    <Typography variant="body2" color="text.secondary">
                        {subtitle}
                    </Typography>
                )}
            </CardContent>
        </Card>
    );
};

export default DashboardCard;